Ext.define('SA.EditRankingGeographicReleaseRequiredRule', {
    constructor(model) {
        this.model = model;
    },

    getMessage() {
        return SA.view.RankingGrid.getLocationAttributesYearIncompatabilityWarning(this.model);
    },

    isBroken() {
        return this.model.hasNoAttributeInLocationGeographicReleases();
    }
});